enum FEATURE_FLAG {}
export enum DYNAMIC_FEATURE_FLAG {
  INTERCEPTABLE_INVOICE = 'INTERCEPTABLE_INVOICE',
}
export default FEATURE_FLAG;
